<template>
    <v-container>
        <template v-if="loading">
            Loading
        </template>
        <template v-else>
            <div style="margin-top:5em;">
                <template v-if="'simulateur-generique' === this.$route.name">
                    <introduction/>
                </template>
                <template v-else>
                    <introduction-collectivite/>
                </template>
                <legislatif/>
                <glossaire/>
                <tarifs/>
                <support-list/>
            </div>
            <presentation/>
            <navigation/>
        </template>
    </v-container>
</template>

<script>
import introduction from './Introduction.vue'
import IntroductionCollectivite from './IntroductionCollectivite.vue'
import presentation from './Presentation.vue'
import Tarifs from './Tarifs.vue'
import SupportList from './SupportList.vue'
import Glossaire from './Glossaire.vue';
import Navigation from './Navigation.vue';
import Legislatif from './Legislatif.vue';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'Simulateur',
    components: {
        'introduction': introduction,
        'introduction-collectivite': IntroductionCollectivite,
        'glossaire': Glossaire,
        'navigation': Navigation,
        'presentation': presentation,
        'tarifs': Tarifs,
        'legislatif': Legislatif,
        'support-list': SupportList,
    },
    mixins: [],
    props: {},
    data() {
        return {
            loading: true,
        };
    },
    computed: {
        ...mapState('collectivite', ['collectivite', 'tarifs', 'options', 'defaultTarifs', 'defaultOptions']),
    },
    watch: {},
    created() {
        if ('simulateur-collectivite' === this.$route.name && this.$route.params.collectivite) {
            this.getCollectivite(this.$route.params.collectivite)
                .then(() => {
                    if (!this.collectivite) {
                        this.$router.push({ name: 'welcome' });
                    }
                    this.loading = false;
                });
        } else {
            this.setTarifs(this.defaultTarifs).then(() => {
                this.setOptions(this.defaultOptions).then(() => {
                    this.loading = false;
                });
            });
        }
    },
    methods: {
        ...mapActions('collectivite', ['getCollectivite']),
        ...mapActions('tarif', ['setTarifs', 'setOptions']),
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Simulateur/Simulateur.vue